<template>
    <InformeCard
        @click="draw"
        title="Clientes recurrentes vs nuevos"
        v-if="totalRecurrentesVsNuevos"
        id="recurrentes-vs-nuevos"
        name="recurrentes-vs-nuevos"
        collapsable="true"
    >
        <h4 class="text-center">Clientes recurrentes vs nuevos</h4>
        <GChart
            type="PieChart"
            :data="totalRecurrentesVsNuevos"
            :options="chartOptions"
            ref="googleChart"
        />
    </InformeCard>
</template>

<script>
    import InformeCard from "../InformeCard";

    export default {
        props: ["event_id"],
        data() {
            return {
                totalRecurrentesVsNuevos: [],
                chartOptions: {
                    height: 364,
                    chartArea: { width: "100%" },
                    pieHole: 0.4,
                    sliceVisibilityThreshold: 0,
                },
            };
        },
        methods: {
            getRecurrentesVsNuevos() {
                const params = {
                    filters: {},
                    evento_id: this.event_id,
                };
                this.$store
                    .dispatch(
                        this.config.getVuexAlias("back.events.informe.recurrentes-vs-nuevos"),
                        params
                    )
                    .then(res => {
                        this.totalRecurrentesVsNuevos = res.data;
                    });
            },
            draw() {
                setTimeout(() => {
                    // this.$refs.googleChart.drawChart();
                    this.$refs.googleChart.drawChart();
                }, 50);
            },
        },
        created() {
            this.getRecurrentesVsNuevos();
        },
        components: {
            InformeCard,
        },
    };
</script>
